import PropTypes from 'prop-types';
import React from 'react';
import exact from 'prop-types-exact';

const ProBadge = (props) => (

    <span className={props.className}>
        {props.title}
    </span>
);


export default ProBadge;

ProBadge.propTypes = exact({
    className: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
});
